export class BillingSystem {
	public id: number
	public name: string
	public country: string

	constructor(data: { id: number; name: string; country: string }) {
		this.id = data.id
		this.name = data.name
		this.country = data.country
	}

	static create(data: Partial<BillingSystem>): BillingSystem {
		const defaults = {
			id: 0,
			name: '',
			country: '',
		}

		return new BillingSystem({ ...defaults, ...data })
	}

	/**
	 * Check if the billing system is for Mexico (Alegra MEX)
	 */
	isMexican(): boolean {
		return this.name.includes('Alegra MEX')
	}

	/**
	 * Check if the billing system is for Argentina (Alegra ARG)
	 */
	isArgentinian(): boolean {
		return this.name.includes('Alegra ARG')
	}

	/**
	 * Check if the billing system is for Chile (Alegra CHL)
	 */
	isChilean(): boolean {
		return this.name.includes('Alegra CHL') || this.country === 'CHL'
	}

	/**
	 * Check if the billing system is for Spain (Alegra ESP)
	 */
	isSpanish(): boolean {
		return this.name.includes('Alegra ESP')
	}

	/**
	 * Check if the billing system is for Colombia (Alegra COL)
	 */
	isColombian(): boolean {
		return this.name.includes('Alegra COL')
	}

	/**
	 * Check if the billing system is for USA (Alegra USA)
	 */
	isUSA(): boolean {
		return this.name.includes('Alegra USA')
	}
}
